import { render, staticRenderFns } from "./SelecionarParceiro.vue?vue&type=template&id=43e909fe"
import script from "./SelecionarParceiro.vue?vue&type=script&lang=js"
export * from "./SelecionarParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports